import { useMemo } from "react";
import { generatePath, Link } from "react-router";

import type { HpbPageList_HpbPageListPageQuery } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { BlankContentForList } from "@/components/features/_components";
import { FeatureIslandContainer, FeatureIslandMainWithBackGround } from "@/components/features/_layouts";

import { Button } from "@/components/ui/button/button";

import { HPBHeader } from "./header";
import { HPBListItem } from "./list/list-item";
import { useInit } from "../../model/usecase/use-init";

type Props = {
	hotelID: string;
	data: HpbPageList_HpbPageListPageQuery;
};

export const HPBListPresenter = ({ hotelID, data }: Props) => {
	const { TOPPageItem, ordinaryPageList, onDelete } = useInit({ hotelID, data });

	const createNewSnackPath = generatePath(PATHS.HOTEL.HPB.EDIT.NEW, { hotelID });
	/**
	 * 通常ページのリストを表示するか
	 */
	const canShowOrdinaryPageList = useMemo(() => ordinaryPageList.length > 0, [ordinaryPageList.length]);

	return (
		<FeatureIslandContainer>
			<HPBHeader />
			<div className="px-4 py-3 laptop:hidden laptop:px-12">
				<div className="rounded-md border border-zinc-200 bg-zinc-50 px-3 py-2 text-xs">
					スナックの設定はPC版からのみ変更できます
				</div>
			</div>

			{TOPPageItem && (
				<FeatureIslandMainWithBackGround islandTitle="トップページ">
					<div className="pointer-events-none opacity-50 laptop:pointer-events-auto laptop:opacity-100">
						<HPBListItem hotelID={hotelID} HPBPage={TOPPageItem} onDelete={onDelete} />
					</div>
				</FeatureIslandMainWithBackGround>
			)}

			<FeatureIslandMainWithBackGround islandTitle="通常ページ">
				<div className="pointer-events-none opacity-50 laptop:pointer-events-auto laptop:opacity-100">
					<div className="flex justify-end">
						<Link to={createNewSnackPath} viewTransition>
							<Button type="button" variant="default" size="xl">
								新規作成
							</Button>
						</Link>
					</div>

					{canShowOrdinaryPageList ? (
						<div className="flex flex-col gap-y-4">
							{ordinaryPageList.map((HPBPage) => {
								return (
									<HPBListItem
										key={HPBPage.uuid}
										hotelID={hotelID}
										HPBPage={HPBPage}
										onDelete={onDelete}
									/>
								);
							})}
						</div>
					) : (
						<BlankContentForList
							content={`通常ページがありません。\n新規作成ボタンから通常ページを作成してください。`}
						/>
					)}
				</div>
			</FeatureIslandMainWithBackGround>
		</FeatureIslandContainer>
	);
};

HPBListPresenter.displayName = "HPBListPresenter";
